import _ from "lodash";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import Slider from "react-slick";
import shared, { dp } from "../../../utils/shared.js";
import MenuOmaha from "./MenuOmaha";
import { slideEdgePadding, slideWidth } from "./OmahaConstants";
import StoriesButtonOmaha from "./StoriesButtonOmaha";
import get from "lodash/get";

const itemsPerRowActual = 3;
const itemsPerRow = itemsPerRowActual + 2; // includes 2 dummies

const totalSlidesPerPageActual = itemsPerRowActual * 2;
const totalSlidesPerPage = itemsPerRow * 2; // includes 4 dummies

class StoriesOmaha extends Component {
  constructor(props) {
    super(props);
    /*eslint no-extend-native: ["warn", { "exceptions": ["Array"] }]*/
    Array.prototype.diff = function (a) {
      return this.filter(function (i) {
        return a.indexOf(i) < 0;
      });
    };

    let currentSlide = _.get(this.props, "module.currentSlide", 0);
    this._storiesRefs = [];
    this._stories = null;
    this._colors = ["#8e7d96", "#d2b78c", "#7088a1", "#aeb17c", "#cc7370", "#fdbc48"];
    this._handIconRef = null;
    this._headline = null;
    this._background = null;
    this._icon = null;

    this.setupElements();
    this.getSlides();

    this.state = {
      initializedRefs: false,
      handPositionX: 0,
      handPositionY: 0,
      handOpacity: 0,
      changeHeadlineFontSize: false,
      currentSlide: currentSlide,
      headline: this.props.module.name.toUpperCase()
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.module !== this.props.module) {
      if (this.props.module.display_module_type && this.props.module.display_module_type === "Stories") {
        this.removeRefsEvents();
        this._storiesRefs = [];
        this.setupElements();
        this.getSlides();
        this.setState({
          initializedRefs: false
        });
        this.initializeSwipeHandIcon();
        setTimeout(() => {
          this.initializeStoriesRefs();
        }, 250);
        this.setState({
          headline: this.props.module.name.toUpperCase()
        });
        this._icon = this.getIcon();
      }
    }
  }

  componentDidMount() {
    this.initializeStoriesRefs();
    this.checkHeadlineSize();
    this.initializeSwipeHandIcon();
    this._background = this.getBackgroundImage();
    this._icon = this.getIcon();
  }

  componentWillUnmount() {
    this.removeRefsEvents();
  }

  removeRefsEvents = () => {
    if (this._storiesRefs.length > 0) {
      for (let a = 0; a < this._storiesRefs.length; a++) {
        if (this._storiesRefs[a].el) {
          this._storiesRefs[a].el.removeEventListener("click", () => this.handleNav(this._storiesRefs[a].data));
        }
      }
    }
  };

  checkHeadlineSize = () => {
    if (!this._headlineRef) {
      setTimeout(() => {
        this.checkHeadlineSize();
      }, 100);
    } else {
      let maxAllowed = (this.props.screen.screenHeight * 37.83) / 100;
      let width = this._headlineRef.getBoundingClientRect().width;

      if (width > maxAllowed) {
        this.setState({
          changeHeadlineFontSize: true,
          headlineFontSize: (this.props.screen.screenHeight * 3) / 100
        });
      }
    }
  };

  getBackgroundImage = () => {
    let defaultImg = { path: "/img/omaha/general/", file_name: "story-background.jpg" };

    if (this.props.screensNumber === 2) {
      defaultImg.file_name = "default_double_screen.jpg";
    }

    try {
      let backgroundReference = this.props.module.contents.custom_fields.background_reference.val;
      let assetsSlideShow = _.find(this.props.content.dm_active, function (o) {
        return o.name.includes("Assets");
      });
      let asset = _.indexOf(assetsSlideShow.contents.names, backgroundReference);

      if (!asset || asset === undefined) {
        return dp(this.props.screen, defaultImg);
      }

      return dp(this.props.screen, assetsSlideShow.contents.images[asset]);
    } catch (e) {
      return dp(this.props.screen, defaultImg);
    }
  };

  getIcon = () => {
    return dp(this.props.screen, _.get(this.props.module, "module_contents.icon", null));
  };

  initializeStoriesRefs = () => {
    if (this.state.initializedRefs === false && this._storiesRefs.length > 0) {
      for (let a = 0; a < this._storiesRefs.length; a++) {
        if (this._storiesRefs[a] && this._storiesRefs[a].el) {
          this._storiesRefs[a].el.addEventListener("click", () => this.handleNav(this._storiesRefs[a].data));
        }
      }
      this.setState({
        initializedRefs: true
      });
    }
  };

  initializeSwipeHandIcon = () => {
    let storySlick = ReactDOM.findDOMNode(this._slickRef).getElementsByClassName("story-slick");
    this._domeTimeHandler = setTimeout(() => {
      if (storySlick.length > 0 && this._handIconRef) {
        if (storySlick[0].childNodes[0]) {
          let firstBullet = storySlick[0].childNodes[0].getBoundingClientRect();
          this.setState({
            handPositionX: firstBullet.x - this.props.screen.screenHeight * 0.03 * 1.25,
            handPositionY: firstBullet.y + this._handIconRef.getBoundingClientRect().height * 0.25,
            handOpacity: 1
          });
        }
      }
    }, 150);
  };

  handleNav = (route) => {
    this.props.navRoute(route.navLocation);
  };

  setupElements = () => {
    let stories = _(this.props.content.folder_modules)
      .filter({ folder: Number(this.props.module.contents.folder), model: "story" })
      .map((fm) => {
        return {
          ..._.find(this.props.content.stories, { id: Number(fm.module_id) }),
          folder_module_id: fm.id
        };
      })
      .compact()
      .value();

    const moduleAssociatedFolder = get(this.props.module, "contents.folder", null);
    // console.log('this.props.module', this.props.module);

    const storyCategories = this.props.content.story_categories.filter(
      (sc) =>
        Number(sc.parent_category) === Number(moduleAssociatedFolder) &&
        get(sc, "contents.custom_fields.folder_type.val.value", null) === "donor_lists"
    );

    let handIcon = dp(this.props.screen, null, { path: "/img/ui/", file_name: "handIconSwipe.png" });
    this._stories = stories;
    this._donorLists = storyCategories;
    this._handIcon = handIcon;
  };

  setRefs = (i, data) => {
    this._storiesRefs[i] = data;
  };

  getSlides = () => {
    let slides = [];
    let separationFromAbove = 1.48;
    let count = 0;

    const storiesAndDonorLists = _.orderBy(
      this._stories.concat(this._donorLists),
      ["sorting_name", "name", "createdAt"],
      ["asc", "desc"]
    );

    slides = storiesAndDonorLists.map((story, i) => {
      count++;
      let marginLeft = "1.75vh";
      let marginTop = 0;
      let storyObj = Object.assign({}, story);
      storyObj.display_module_id = this.props.module.id;

      if (i === 0 || i % itemsPerRowActual === 0) {
        marginLeft = 0;
      }

      if (count > itemsPerRowActual) {
        marginTop = separationFromAbove;
      }

      if (count === totalSlidesPerPageActual) {
        count = 0;
      }

      let currentSlide = _.get(this.state, "currentSlide", 0);

      return (
        <div key={i + 100}>
          <StoriesButtonOmaha
            background={_.get(story.contents, "images[0]", null)}
            categoryIcon={_.get(this.props.module, "module_contents.icon", null)}
            currentSlide={currentSlide}
            icon={_.get(story.contents, "images[0]", null)}
            marginLeft={marginLeft}
            marginTop={marginTop}
            name={story.name}
            overrideStoryName={this.props.module.name.toUpperCase()}
            refIndex={i}
            screen={this.props.screen}
            setRefs={this.setRefs}
            story={storyObj}
            tint={this._colors[i % this._colors.length]}
          />
        </div>
      );
    });

    return slides;
  };

  getGrouppedSlides = (slides) => {
    let slidesToGroup = [];
    let grouppedSlides = [];
    let grouppedSlidesV2 = [];
    let groups = [];
    let count = 0;
    let lineCounter = 0;
    let slideIndex = 0;
    let pageCount = Math.ceil(slides.length / totalSlidesPerPageActual);
    let slideCountWithDummies = pageCount * totalSlidesPerPage;

    const slideDataWithDummies = [];

    count = 0;

    // console.log("______________________________--");
    // pad for 2 on each side
    for (let ii = 0; ii < slideCountWithDummies; ii++) {
      if (lineCounter === 0 || lineCounter === itemsPerRow - 1) {
        // console.log("lineCounter:", lineCounter, "dummy side");
        slideDataWithDummies.push(this.getDummyBlock(ii, true));
      } else if (slideIndex < slides.length) {
        // console.log("lineCounter:", lineCounter, "slide: " + slideIndex);
        slideDataWithDummies.push(slides[slideIndex]);
        slideIndex++;
      } else {
        // console.log("lineCounter:", lineCounter, "dummy regular");
        slideDataWithDummies.push(this.getDummyBlock(ii, false));
      }
      lineCounter++;
      if (lineCounter > itemsPerRow - 1) {
        lineCounter = 0;
      }
    }

    // console.log("slideDataWithDummies", slideDataWithDummies);

    slideDataWithDummies.forEach((preparedSlide, i) => {
      if (count === 0) {
        slidesToGroup = [];
      }
      slidesToGroup.push(preparedSlide);
      count++;
      if (count >= totalSlidesPerPage) {
        grouppedSlidesV2.push(slidesToGroup);
        count = 0;
      }
    });

    groups = grouppedSlidesV2.map((group, i) => {
      //TODO: should have some left / centering?
      let left = `${100 * i}vw`;
      return (
        <div key={i} style={{ position: "absolute", left: left, fontSize: "100px" }}>
          {group}
        </div>
      );
    });

    return groups;
  };

  getDummyBlock = (i, isPadding) => {
    const ww = isPadding ? slideEdgePadding : slideWidth;
    return (
      <div
        key={i}
        style={{
          position: "relative",
          float: "left",
          width: ww,
          height: slideWidth
        }}
      />
    );
  };

  getRandomUnrepeatedColors = () => {
    let storiesLength = this._stories.length;
    let pulledColors = [];

    for (let i = 0; i < storiesLength; i++) {
      let colorsLeft = this._colorsIndexes.diff(pulledColors);

      if (colorsLeft.length === 0) {
        colorsLeft = this._colorsIndexes;
      }

      let index = shared.getRandomInt(0, colorsLeft.length - 1);
      pulledColors.push(colorsLeft[index]);
    }

    return pulledColors;
  };

  render() {
    const settings = {
      arrows: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      dotsClass: "story-slick",
      initialSlide: this.state.currentSlide,
      afterChange: (current) => this.setState({ currentSlide: current })
    };
    let slides = this.getSlides();
    let grouppedSlides = this.getGrouppedSlides(slides);
    const backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;
    const textShadow = "0.30vh 0.30vh 0.54vh rgba(51, 51, 51, 0.76)";
    let headlineFontSize = "3.5vh";
    if (this.state.changeHeadlineFontSize) {
      headlineFontSize = this.state.headlineFontSize;
    }

    return (
      <div>
        <div
          style={{
            height: this.props.screen.screenHeight,
            width: this.props.screen.screenWidth,
            textAlign: "center",
            backgroundSize: backgroundSize,
            backgroundImage: "url(" + this._background + ")"
          }}
        >
          <div
            style={{
              backgroundColor: "#8c827a",
              height: "7.16vh",
              width: "100%",
              position: "absolute",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <span
              ref={(el) => (this._headlineRef = el)}
              style={{
                textShadow: textShadow,
                fontSize: headlineFontSize,
                fontWeight: "bold",
                marginTop: "1.83vh",
                marginBottom: "1.83vh"
              }}
            >
              {this.state.headline}
            </span>
            <img
              className="shadowed-image"
              style={{ position: "absolute", maxHeight: "5.3vh", right: "1vh", top: "1vh" }}
              src={this._icon}
              alt=""
            />
          </div>
          <div style={{ position: "absolute", width: "100%", height: "16.58vh", top: "37vh" }}>
            <span style={{ fontSize: "3vh", color: "#51544c" }}>Touch a story to</span>
            <br />
            <span style={{ fontSize: "3vh", color: "#51544c" }}>learn more.</span>
          </div>
          <div style={{ position: "absolute", width: "100%", height: "16.58vh", top: "45vh" }}>
            <img
              style={{ width: "7.017vh", height: "7.017vh" }}
              src={dp(this.props.screen, null, { path: "/img/ui/", file_name: "handicon-04.png" })}
              alt=""
            />
          </div>
          <div
            className="omaha-stories-slider"
            style={{ position: "absolute", bottom: "10vh", width: "100vw", maxWidth: "100vw", height: "32.2925vh" }}
          >
            <Slider ref={(el) => (this._slickRef = el)} {...settings}>
              {grouppedSlides}
            </Slider>
          </div>
          <div style={{ position: "absolute", bottom: "0vh", width: "100%" }}>
            <MenuOmaha navRoute={this.props.navRoute} currentModuleId={this.props.module.id} />
          </div>
          {grouppedSlides.length > 1 ? (
            <img
              alt="handicon"
              ref={(el) => (this._handIconRef = el)}
              src={this._handIcon}
              style={{
                opacity: this.state.handOpacity,
                left: this.state.handPositionX,
                top: this.state.handPositionY,
                position: "absolute",
                width: "2.4vh"
              }}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

export default StoriesOmaha;



// WEBPACK FOOTER //
// ./src/Components/Theme/Omaha/StoriesOmaha.jsx